import BaseModel, { type IResourceName } from 'volta/models/base-model';
import { collectionCommand, resourceCommand as command } from 'volta/utils/api';

import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { ICreateWarehouseCmd, IUpdateWarehouseCmd } from 'volta/models/types/warehouse';

export const WarehouseResourceName: IResourceName = {
  singular: 'warehouse',
  plural: 'warehouses'
};

export enum WarehouseEvents {
  WarehouseCreated = 'WarehouseCreated',
  WarehouseUpdated = 'WarehouseUpdated',
  WarehouseDeleted = 'WarehouseDeleted'
}

enum TWarehouseCommands {
  CreateWarehouse = 'CreateWarehouse',
  UpdateWarehouse = 'UpdateWarehouse'
}

export interface IWarehouse {
  code?: string;
  description?: string;
}

export default class Warehouse extends BaseModel {
  static createWarehouse = collectionCommand<ICreateWarehouseCmd, Warehouse, typeof Warehouse>(
    TWarehouseCommands.CreateWarehouse
  );

  updateWarehouse = command<IUpdateWarehouseCmd, Warehouse>(TWarehouseCommands.UpdateWarehouse);

  @attr('string') code!: string;
  @attr('string') description?: string;
  @attr('string') currency?: string;
  @attr('string') externalId?: string;

  get warehouseId() {
    return this.id;
  }

  [Type] = 'warehouse' as const;
}
